<template>
  <div :class="allClasses">
    <EThumbnail
      :src="src"
      :fit="fit"
      :image-overlay="imageOverlay"
      class="snippet-thumbnail__image"
      data-test-id="snippet-thumbnail-image"
      role="presentation"
      fallback="trees"
      @error="error = true"
      @load="loaded = true"
    />
    <EDurationTag
      v-if="duration"
      :duration="duration"
      class="snippet-thumbnail__duration"
      data-test-id="snippet-thumbnail-duration"
    />
  </div>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';
import EThumbnail from '~~/common/vue/components/thumbnail';
import EDurationTag from '~~/search/common/vue/components/duration-tag';

export default {
  name: 'ESnippetThumbnail',
  components: {
    EThumbnail,
    EDurationTag,
  },
  mixins: [classes],
  props: {
    duration: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    fit: EThumbnail.props.fit,
    imageOverlay: EThumbnail.props.imageOverlay,
    padded: {
      type: Boolean,
      default: false,
      cssClass: true,
    },
  },
  data() {
    return {
      error: false,
      loaded: false,
    };
  },
  computed: {
    allClasses() {
      const allClasses = [...this.classes];
      if (this.error) {
        allClasses.push('snippet-thumbnail--error');
      }
      if (this.loaded) {
        allClasses.push('snippet-thumbnail--loaded');
      }
      return allClasses;
    },
  },
};
</script>
<style lang="scss" scoped>
.snippet-thumbnail {
  position: relative;
  overflow: hidden;
  padding-bottom: aspect-ratio(16, 9);
  height: 0;
}

.snippet-thumbnail--error {
  background-color: var(--color-background-secondary);
}

// Workaround for a Chrome bug where a combination
// of the image pre-fetching in our common Thumbnail
// and the padding aspect-ratio technique above
// caused the images not to be painted until reflow.
// The style below is applied once the thumbnail is loaded
// and triggers reflow/repaint of the images.
.snippet-thumbnail--loaded {
  height: auto;
}

.snippet-thumbnail__image {
  display: flex;
  justify-content: center;
  height: 100%;
  position: absolute;
  width: 100%;

  .snippet-thumbnail--padded & {
    padding: $space-1s;
  }
}

.snippet-thumbnail__duration {
  position: absolute;
  bottom: $space-1s;
  right: $space-1s;
}
</style>
